import React from 'react';
import PointsIcon from '../Icons/Points';
import { IconSize } from '../Icons/IconWrap';
import { useFlag } from '../redux/flags/hooks';
import s from './CommissionPointsAndPrice.scss';
var CommissionPointsAndPrice = function (_a) {
    var points = _a.points, price = _a.price;
    var newPriceFormat = useFlag('new_price_format');
    return (React.createElement("div", { className: s['root'] },
        (!newPriceFormat || points < 80) && (React.createElement("div", { className: s['points-value'] },
            React.createElement(PointsIcon, { className: s['points-icon'], size: IconSize.SMALLER }),
            points)),
        React.createElement("div", { className: s['dollars-cost'] },
            newPriceFormat ? '' : '$',
            price)));
};
CommissionPointsAndPrice.displayName = 'CommissionPointsAndPrice';
export default CommissionPointsAndPrice;
//# sourceMappingURL=CommissionPointsAndPrice.js.map